// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"9245c9d0","453":"967d77cc","865":"3759e3ce"}[chunkId] + ".chunk.js";
};